import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ProfileWidget from "./ProfileWidget";
import { APP_ENV } from "../../config";
import { logout } from "../../utils";
import { ModalConfirm } from "tamtam-components";
import _ from "../../i18n";

const Profile = ({ contact, scrollToTop }) => {
  const [isWidgetLoaded, setIsWidgetLoaded] = useState(false);
  const auth = useSelector(state => state.auth);
  const { token, jwtToken, user, scope, goPeopleUserId } = auth;
  const language = useSelector(state => state.params.language);
  const [isOpen, setIsOpen] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const selectedOrganizationId = auth?.navCommunity?.id;
  const userId = auth?.user?.id;

  useEffect(
    () => {
      if (scope?.includes("_ls")) {
        setShouldRender(false);
        setIsOpen(true);
      } else {
        setShouldRender(true);
      }
      const script = document.createElement("script");
      let userSelected = contact ?? user;

      if (userSelected) {
        script.src = `https://s3.tamtam.pro/cdn/profile/gopeople/${
          APP_ENV === "rc2"
            ? "staging"
            : APP_ENV === "v2" || APP_ENV === "production"
              ? "production"
              : APP_ENV
        }/static/js/profileWidget.js?t=${APP_ENV !== 'v2' && APP_ENV !== 'production' ? Date.now() : ''}`;
        script.async = true;
        script.onload = () => {
          setIsWidgetLoaded(true);
        };

        document.body.appendChild(script);
      }

      return () => {
        if (userSelected) {
          document.body.removeChild(script);
        }
      };
    },
    [user, contact],
  );

  if (isWidgetLoaded) {
    let userSelected = contact ?? user;
    // Use contact's goPeople user ID if available, otherwise use logged-in user's ID
    const widgetUserId = contact?.user_id || goPeopleUserId;
    console.log(contact, widgetUserId, userId, auth);

    return (
      <>
        {!shouldRender ? (
          <ModalConfirm
            type="logout"
            isOpen={isOpen}
            onCancel={() => {
              setIsOpen(false);
              window.history.back();
            }}
            onConfirm={() => logout()}
            inProcess={false}
            title={_("confirm_logout_title")}
            text={_("confirm_logout_text")}
            labelNo={_("cancel")}
            labelYes={_("connection")}
            labelError={_("error")}
          />
        ) : (
          <>
            <link 
              href={
                APP_ENV == "staging"
                  ? "https://s3.tamtam.pro/cdn/profile/gopeople/staging/static/css/profileWidget.css"
                  : APP_ENV === "v2"
                    ? "https://s3.tamtam.pro/cdn/profile/gopeople/production/static/css/profileWidget.css"
                    : `https://s3.tamtam.pro/cdn/profile/gopeople/${APP_ENV}/static/css/profileWidget.css`
              }
              rel="stylesheet"
            />
            <ProfileWidget
              token={jwtToken}
              lng={language}
              user_uuid={contact?.id ? null : widgetUserId}
              isContact={!!contact}
              onScrollToTop={scrollToTop}
              selectedOrganization={selectedOrganizationId}
              updatedByUser={userId}
              ttp_user_id={contact?.id}
            /></>)}
      </>
    );
  }
  return null;
};

export default Profile;
